import { render, staticRenderFns } from "./SimpleEditableList.vue?vue&type=template&id=995cef28&scoped=true&"
import script from "./SimpleEditableList.vue?vue&type=script&lang=js&"
export * from "./SimpleEditableList.vue?vue&type=script&lang=js&"
import style0 from "./SimpleEditableList.vue?vue&type=style&index=0&id=995cef28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995cef28",
  null
  
)

export default component.exports